module.exports = __webpack_public_path__ + "static/about-us-a6cb89ed356d65142b3f17e70fb848be.png";